module.exports = __webpack_public_path__ + "img/income.0dd4983.svg";